import { useEffect, useState } from 'react';
import { PartIdCount, SparePartCount } from '../interfaces/Item';
import { getImageSrc, sparePartService } from '../services';
import { StatusType } from '../interfaces/Cart';
import { useCart } from '../contexts/Cart';

interface ConfirmState {
  loading: boolean;
  status: StatusType;
  items: SparePartCount[];
  error: boolean;
}

export const useConfirm = (id: string, token: string): ConfirmState => {
  const cartContext = useCart();
  const [status, setStatus] = useState<StatusType>('PENDING');
  const [items, setItems] = useState<SparePartCount[]>(cartContext.getItems());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        if (id && token) {
          setLoading(true);
          const result = await sparePartService.fetchSparePartConfirmOrderId(id, token);
          const cartItemToItemQuantity = (
            item: PartIdCount
          ): SparePartCount => {
            return {
              item: {
                id: item.partId,
                imageSrc: getImageSrc(item.partId),
                replacementId: '',
                stock: 0,
                description: '',
                name: '',
                status: 'AVAILABLE',
                categoryId: '',
                subCategoryId: '',
              },
              quantity: item.quantity,
            };
          };
          const newItems = result.cart.cartItems.map(cartItemToItemQuantity);
          setStatus(result.status);
          setItems(newItems);
        }
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [id, token]);

  return { status, loading, items, error };
};
